import { FAILURE, FETCHING, SUCCESS } from '../fetchStatus';
import {
  FETCH_REDIRECTS_REQUEST,
  FETCH_REDIRECTS_SUCCESS,
  FETCH_REDIRECTS_FAILURE,
} from '../actionTypes';

const initialState = null;

export default function redirects(state = initialState, action) {
  switch (action.type) {
    case FETCH_REDIRECTS_REQUEST:
      return { status: FETCHING };

    case FETCH_REDIRECTS_SUCCESS:
      return { status: SUCCESS, data: action.payload.redirects };

    case FETCH_REDIRECTS_FAILURE:
      return { status: FAILURE, error: action.payload.error };

    default:
      return state;
  }
}